import { createStore } from "vuex";
import vuexPersist from "@/store/persit";
import SimModule from "@/store/sim";
import ResourceModule from "@/store/resource";
import AuthModule from "@/store/auth";
import MemberModule from "@/store/member";
import CmpModule from "@/store/cmp";
import MessageModule from "@/store/message";
import RoleModule from "@/store/role";
import ManualModule from "@/store/manual";
import AutomationModule from "@/store/automation";
import CmpTypeModule from "@/store/cmp-type";
import LoadingModule from "@/store/loading";
import PaginateModule from "@/store/paginate";
import FilterModule from "@/store/filter";
import WebSocketModule from "@/store/websocket";
import RecievedSimDataModule from "@/store/recieved-sim-data";
import Notification from "@/store/notification";
import SortModule from "@/store/sort";
import OtaModule from "@/store/ota";
import OtaTableModule from "@/store/ota-table";
import TableViewModule from "@/store/table-view";
import GoogleMapModule from "@/store/google-map";
import BusyModule from "@/store/busy";
import CameraEventModule from "@/store/camera-demo";
import IotSafeCertificatesModule from "@/store/iot-safe-certificates";
import IotSafeFilesModule from "@/store/iot-safe-files";
import IotSafeSimsModule from "@/store/iot-safe-sims";
import SigningHistoryModule from "@/store/signingHistory";
import ESimModule from "@/store/esim";
import ProfileModule from "@/store/profile";
import VpnConnectedClientsModule from "@/store/vpn-connected-clients";
export default createStore({
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    sim: SimModule,
    resource: ResourceModule,
    auth: AuthModule,
    member: MemberModule,
    cmp: CmpModule,
    message: MessageModule,
    role: RoleModule,
    manual: ManualModule,
    automation: AutomationModule,
    cmpType: CmpTypeModule,
    loading: LoadingModule,
    paginate: PaginateModule,
    filter: FilterModule,
    websocket: WebSocketModule,
    recievedSimData: RecievedSimDataModule,
    notification: Notification,
    sort: SortModule,
    ota: OtaModule,
    otaTable: OtaTableModule,
    tableView: TableViewModule,
    googleMap: GoogleMapModule,
    busy: BusyModule,
    cameraEvent: CameraEventModule,
    "iot-safe-certificates": IotSafeCertificatesModule,
    IotSafeFilesModule,
    iotsafeSims: IotSafeSimsModule,
    signingHistory: SigningHistoryModule,
    esim: ESimModule,
    profile: ProfileModule,
    vpnConnectedClients: VpnConnectedClientsModule,
  },
  plugins: [vuexPersist.plugin],
});
